import React from "react";
import InputText from "../ReusableComponents/InputText";
import { staffsalaryHeader } from '../components/HeaderAttribute';
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";

const Payrollpopup = ({ data }) => {
  
  const salary = data || {};

  // Debugging
  console.log("popUpData:", data);

  return (
    <div className="p-6">
      <div className="grid gap-4 mb-6 md:grid-cols-3">
        {/* Date */}
        <InputText
          inputType="date"
          title="Date"
          content={[]}
          classStar="text-red-500"
          name="salaryDate"
          disabled="disabled"
        />

        {/* Staff Name Input */}
        <InputText
          inputType="text"
          title="month"
          name="staffName"
          content={salary.StaffName || ""}
          classStar="text-red-500"
          disabled="disabled"
        />

       

        {/* Gross Salary Section */}
       
        
      </div>

      <div className="font-semibold col-span-3"> Staff Salary Details</div>
        
        <GridPageWithCheckBox
                            header={staffsalaryHeader}
                            records={[]}
                            // checkBoxStatus={handle1}
                            // onSelectedGrid={setSelectedRowData}
                            isMultiSelect={true}
                            checkBoxVisible={true}
                            addView={true}
                            checkBoxHeaderVisible={true}
                            rowsPerPageView={true}
        
                            // selectedRows={selectedRows ?? []}
                          />
    </div>
  );
};

export default  Payrollpopup ;